/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  EarnClaimPolicyResponse,
  EarnQrRedeemBody,
  EarnQrRedeemResponse,
  EarnReferralBody,
  EarnReferralResponse,
  EarnSerialVerifyBody,
  EarnSerialVerifyResponse,
  EarnSocialFollowBody,
  EarnSocialFollowResponse,
  EarnSocialLikeBody,
  EarnSocialLikeResponse,
  EarnSocialPostBody,
  EarnSocialPostResponse,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    EarnClaimPolicyResponseFromJSON,
    EarnClaimPolicyResponseToJSON,
    EarnQrRedeemBodyFromJSON,
    EarnQrRedeemBodyToJSON,
    EarnQrRedeemResponseFromJSON,
    EarnQrRedeemResponseToJSON,
    EarnReferralBodyFromJSON,
    EarnReferralBodyToJSON,
    EarnReferralResponseFromJSON,
    EarnReferralResponseToJSON,
    EarnSerialVerifyBodyFromJSON,
    EarnSerialVerifyBodyToJSON,
    EarnSerialVerifyResponseFromJSON,
    EarnSerialVerifyResponseToJSON,
    EarnSocialFollowBodyFromJSON,
    EarnSocialFollowBodyToJSON,
    EarnSocialFollowResponseFromJSON,
    EarnSocialFollowResponseToJSON,
    EarnSocialLikeBodyFromJSON,
    EarnSocialLikeBodyToJSON,
    EarnSocialLikeResponseFromJSON,
    EarnSocialLikeResponseToJSON,
    EarnSocialPostBodyFromJSON,
    EarnSocialPostBodyToJSON,
    EarnSocialPostResponseFromJSON,
    EarnSocialPostResponseToJSON,
} from '../models/index';

export interface CreateEarnQrRedeemRequest {
    earnQrRedeemBody: EarnQrRedeemBody;
}

export interface CreateEarnReferralRequest {
    earnReferralBody: EarnReferralBody;
}

export interface CreateEarnSerialVerifyRequest {
    earnSerialVerifyBody: EarnSerialVerifyBody;
}

export interface CreateEarnSocialFollowRequest {
    earnSocialFollowBody: EarnSocialFollowBody;
}

export interface CreateEarnSocialLikeRequest {
    earnSocialLikeBody: EarnSocialLikeBody;
}

export interface CreateEarnSocialPostRequest {
    earnSocialPostBody: EarnSocialPostBody;
}

export interface GetEarnClaimPolicyObjectiveTemplateIdRequest {
    objectiveTemplateId: string;
}

/**
 * EarnApi - interface
 * 
 * @export
 * @interface EarnApiInterface
 */
export interface EarnApiInterface {
    /**
     * Redeems a minted earn QR token for the authenticated user. Scoring is resolved by the event pipeline from the active assignment\'s configuration.
     * @param {EarnQrRedeemBody} earnQrRedeemBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EarnApiInterface
     */
    createEarnQrRedeemRaw(requestParameters: CreateEarnQrRedeemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EarnQrRedeemResponse>>;

    /**
     * Redeems a minted earn QR token for the authenticated user. Scoring is resolved by the event pipeline from the active assignment\'s configuration.
     */
    createEarnQrRedeem(requestParameters: CreateEarnQrRedeemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EarnQrRedeemResponse>;

    /**
     * Claims a referral invite against the objective\'s active assignment. The invite template, sender name and per-period cap are the assignment\'s policy; scoring is resolved by the pipeline.
     * @param {EarnReferralBody} earnReferralBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EarnApiInterface
     */
    createEarnReferralRaw(requestParameters: CreateEarnReferralRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EarnReferralResponse>>;

    /**
     * Claims a referral invite against the objective\'s active assignment. The invite template, sender name and per-period cap are the assignment\'s policy; scoring is resolved by the pipeline.
     */
    createEarnReferral(requestParameters: CreateEarnReferralRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EarnReferralResponse>;

    /**
     * Verifies product-serial ownership through the objective\'s configured vendor adapter and emits the verification event; scoring is resolved by the pipeline.
     * @param {EarnSerialVerifyBody} earnSerialVerifyBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EarnApiInterface
     */
    createEarnSerialVerifyRaw(requestParameters: CreateEarnSerialVerifyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EarnSerialVerifyResponse>>;

    /**
     * Verifies product-serial ownership through the objective\'s configured vendor adapter and emits the verification event; scoring is resolved by the pipeline.
     */
    createEarnSerialVerify(requestParameters: CreateEarnSerialVerifyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EarnSerialVerifyResponse>;

    /**
     * Claims a social follow against the objective\'s active assignment. The accepted platform is the assignment\'s policy; scoring is resolved by the pipeline.
     * @param {EarnSocialFollowBody} earnSocialFollowBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EarnApiInterface
     */
    createEarnSocialFollowRaw(requestParameters: CreateEarnSocialFollowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EarnSocialFollowResponse>>;

    /**
     * Claims a social follow against the objective\'s active assignment. The accepted platform is the assignment\'s policy; scoring is resolved by the pipeline.
     */
    createEarnSocialFollow(requestParameters: CreateEarnSocialFollowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EarnSocialFollowResponse>;

    /**
     * Claims a social like against the objective\'s active assignment. Accepted platforms and brand-named target posts are the assignment\'s policy; scoring is resolved by the pipeline.
     * @param {EarnSocialLikeBody} earnSocialLikeBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EarnApiInterface
     */
    createEarnSocialLikeRaw(requestParameters: CreateEarnSocialLikeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EarnSocialLikeResponse>>;

    /**
     * Claims a social like against the objective\'s active assignment. Accepted platforms and brand-named target posts are the assignment\'s policy; scoring is resolved by the pipeline.
     */
    createEarnSocialLike(requestParameters: CreateEarnSocialLikeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EarnSocialLikeResponse>;

    /**
     * Claims a social post against the objective\'s active assignment. The post is content-verified through the shared verifier (required hashtag + accepted platforms from the assignment\'s policy); scoring is resolved by the pipeline.
     * @param {EarnSocialPostBody} earnSocialPostBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EarnApiInterface
     */
    createEarnSocialPostRaw(requestParameters: CreateEarnSocialPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EarnSocialPostResponse>>;

    /**
     * Claims a social post against the objective\'s active assignment. The post is content-verified through the shared verifier (required hashtag + accepted platforms from the assignment\'s policy); scoring is resolved by the pipeline.
     */
    createEarnSocialPost(requestParameters: CreateEarnSocialPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EarnSocialPostResponse>;

    /**
     * The active assignment\'s claim policy for this objective, plus the requesting member\'s usage of it this period. Drives the claim form\'s platforms, copy and remaining-claims line.
     * @param {string} objectiveTemplateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EarnApiInterface
     */
    getEarnClaimPolicyObjectiveTemplateIdRaw(requestParameters: GetEarnClaimPolicyObjectiveTemplateIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EarnClaimPolicyResponse>>;

    /**
     * The active assignment\'s claim policy for this objective, plus the requesting member\'s usage of it this period. Drives the claim form\'s platforms, copy and remaining-claims line.
     */
    getEarnClaimPolicyObjectiveTemplateId(requestParameters: GetEarnClaimPolicyObjectiveTemplateIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EarnClaimPolicyResponse>;

}

/**
 * 
 */
export class EarnApi extends runtime.BaseAPI implements EarnApiInterface {

    /**
     * Redeems a minted earn QR token for the authenticated user. Scoring is resolved by the event pipeline from the active assignment\'s configuration.
     */
    async createEarnQrRedeemRaw(requestParameters: CreateEarnQrRedeemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EarnQrRedeemResponse>> {
        if (requestParameters['earnQrRedeemBody'] == null) {
            throw new runtime.RequiredError(
                'earnQrRedeemBody',
                'Required parameter "earnQrRedeemBody" was null or undefined when calling createEarnQrRedeem().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/earn/qr-redeem`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EarnQrRedeemBodyToJSON(requestParameters['earnQrRedeemBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EarnQrRedeemResponseFromJSON(jsonValue));
    }

    /**
     * Redeems a minted earn QR token for the authenticated user. Scoring is resolved by the event pipeline from the active assignment\'s configuration.
     */
    async createEarnQrRedeem(requestParameters: CreateEarnQrRedeemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EarnQrRedeemResponse> {
        const response = await this.createEarnQrRedeemRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Claims a referral invite against the objective\'s active assignment. The invite template, sender name and per-period cap are the assignment\'s policy; scoring is resolved by the pipeline.
     */
    async createEarnReferralRaw(requestParameters: CreateEarnReferralRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EarnReferralResponse>> {
        if (requestParameters['earnReferralBody'] == null) {
            throw new runtime.RequiredError(
                'earnReferralBody',
                'Required parameter "earnReferralBody" was null or undefined when calling createEarnReferral().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/earn/referral`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EarnReferralBodyToJSON(requestParameters['earnReferralBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EarnReferralResponseFromJSON(jsonValue));
    }

    /**
     * Claims a referral invite against the objective\'s active assignment. The invite template, sender name and per-period cap are the assignment\'s policy; scoring is resolved by the pipeline.
     */
    async createEarnReferral(requestParameters: CreateEarnReferralRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EarnReferralResponse> {
        const response = await this.createEarnReferralRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Verifies product-serial ownership through the objective\'s configured vendor adapter and emits the verification event; scoring is resolved by the pipeline.
     */
    async createEarnSerialVerifyRaw(requestParameters: CreateEarnSerialVerifyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EarnSerialVerifyResponse>> {
        if (requestParameters['earnSerialVerifyBody'] == null) {
            throw new runtime.RequiredError(
                'earnSerialVerifyBody',
                'Required parameter "earnSerialVerifyBody" was null or undefined when calling createEarnSerialVerify().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/earn/serial-verify`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EarnSerialVerifyBodyToJSON(requestParameters['earnSerialVerifyBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EarnSerialVerifyResponseFromJSON(jsonValue));
    }

    /**
     * Verifies product-serial ownership through the objective\'s configured vendor adapter and emits the verification event; scoring is resolved by the pipeline.
     */
    async createEarnSerialVerify(requestParameters: CreateEarnSerialVerifyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EarnSerialVerifyResponse> {
        const response = await this.createEarnSerialVerifyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Claims a social follow against the objective\'s active assignment. The accepted platform is the assignment\'s policy; scoring is resolved by the pipeline.
     */
    async createEarnSocialFollowRaw(requestParameters: CreateEarnSocialFollowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EarnSocialFollowResponse>> {
        if (requestParameters['earnSocialFollowBody'] == null) {
            throw new runtime.RequiredError(
                'earnSocialFollowBody',
                'Required parameter "earnSocialFollowBody" was null or undefined when calling createEarnSocialFollow().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/earn/social-follow`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EarnSocialFollowBodyToJSON(requestParameters['earnSocialFollowBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EarnSocialFollowResponseFromJSON(jsonValue));
    }

    /**
     * Claims a social follow against the objective\'s active assignment. The accepted platform is the assignment\'s policy; scoring is resolved by the pipeline.
     */
    async createEarnSocialFollow(requestParameters: CreateEarnSocialFollowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EarnSocialFollowResponse> {
        const response = await this.createEarnSocialFollowRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Claims a social like against the objective\'s active assignment. Accepted platforms and brand-named target posts are the assignment\'s policy; scoring is resolved by the pipeline.
     */
    async createEarnSocialLikeRaw(requestParameters: CreateEarnSocialLikeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EarnSocialLikeResponse>> {
        if (requestParameters['earnSocialLikeBody'] == null) {
            throw new runtime.RequiredError(
                'earnSocialLikeBody',
                'Required parameter "earnSocialLikeBody" was null or undefined when calling createEarnSocialLike().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/earn/social-like`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EarnSocialLikeBodyToJSON(requestParameters['earnSocialLikeBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EarnSocialLikeResponseFromJSON(jsonValue));
    }

    /**
     * Claims a social like against the objective\'s active assignment. Accepted platforms and brand-named target posts are the assignment\'s policy; scoring is resolved by the pipeline.
     */
    async createEarnSocialLike(requestParameters: CreateEarnSocialLikeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EarnSocialLikeResponse> {
        const response = await this.createEarnSocialLikeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Claims a social post against the objective\'s active assignment. The post is content-verified through the shared verifier (required hashtag + accepted platforms from the assignment\'s policy); scoring is resolved by the pipeline.
     */
    async createEarnSocialPostRaw(requestParameters: CreateEarnSocialPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EarnSocialPostResponse>> {
        if (requestParameters['earnSocialPostBody'] == null) {
            throw new runtime.RequiredError(
                'earnSocialPostBody',
                'Required parameter "earnSocialPostBody" was null or undefined when calling createEarnSocialPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/earn/social-post`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EarnSocialPostBodyToJSON(requestParameters['earnSocialPostBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EarnSocialPostResponseFromJSON(jsonValue));
    }

    /**
     * Claims a social post against the objective\'s active assignment. The post is content-verified through the shared verifier (required hashtag + accepted platforms from the assignment\'s policy); scoring is resolved by the pipeline.
     */
    async createEarnSocialPost(requestParameters: CreateEarnSocialPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EarnSocialPostResponse> {
        const response = await this.createEarnSocialPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * The active assignment\'s claim policy for this objective, plus the requesting member\'s usage of it this period. Drives the claim form\'s platforms, copy and remaining-claims line.
     */
    async getEarnClaimPolicyObjectiveTemplateIdRaw(requestParameters: GetEarnClaimPolicyObjectiveTemplateIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EarnClaimPolicyResponse>> {
        if (requestParameters['objectiveTemplateId'] == null) {
            throw new runtime.RequiredError(
                'objectiveTemplateId',
                'Required parameter "objectiveTemplateId" was null or undefined when calling getEarnClaimPolicyObjectiveTemplateId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/earn/claim-policy/{objectiveTemplateId}`;
        urlPath = urlPath.replace(`{${"objectiveTemplateId"}}`, encodeURIComponent(String(requestParameters['objectiveTemplateId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EarnClaimPolicyResponseFromJSON(jsonValue));
    }

    /**
     * The active assignment\'s claim policy for this objective, plus the requesting member\'s usage of it this period. Drives the claim form\'s platforms, copy and remaining-claims line.
     */
    async getEarnClaimPolicyObjectiveTemplateId(requestParameters: GetEarnClaimPolicyObjectiveTemplateIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EarnClaimPolicyResponse> {
        const response = await this.getEarnClaimPolicyObjectiveTemplateIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
